<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>User Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">Member ID</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{modUsrID}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{NAT_NAME_KR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Name</th>
                               <td class="text-left pl-5 tableLinerB">{{USR_NM}}</td>
                               <th class="listHeader tableLinerB" >Phone</th>
                               <td class="text-left pl-5 tableLinerB">{{HP}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Type</th>
                               <td class="text-left pl-5 tableLinerB">{{USR_TYPE}}</td>
                               <th class="listHeader tableLinerB" >Registration Date</th>
                               <td class="text-left pl-5 tableLinerB">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" v-if="USR_COMPNAY_NAME!=''&&USR_COMPNAY_NAME!=undefined">
                        <h3>Company Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                               <th class="listHeader tableLinerT tableLinerB" style="width:20%">Company</th>
                               <td class="tableLinerT tableLinerB text-left pl-5" style="width:30%">{{USR_COMPNAY_NAME}}</td>
                               <th class="listHeader tableLinerB tableLinerT" style="width:20%">Business registration number</th>
                               <td class="tableLinerT tableLinerB text-left pl-5" style="width:30%">{{USR_COMPNAY_NUM}} </td>
                           </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5">
                        <h3>Vehicle Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                               <th class="listHeader tableLinerT tableLinerB" style="width:20%">Vehicle identification number</th>
                               <td class="tableLinerT tableLinerB text-left pl-5" style="width:30%">{{VC_IDTFY_NUMS}}</td>
                               <th class="listHeader tableLinerT tableLinerB " style="width:20%">Vehicle numver registration number</th>
                               <td class="tableLinerT tableLinerB text-left pl-5" style="width:30%">{{VC_NUMS}} </td>
                           </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Agreement Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader tableLinerB tableLinerT" style="width:20%">서비스 이용약관(<span  color="red">필수</span>)</th>
                                    <td class="tableLinerB tableLinerT text-left pl-5" style="width:30%">Agree</td>
                                    <th class="listHeader tableLinerB tableLinerT" style="width:20%">개인정보이용 및 수집동의(<span  color="red">필수</span>)</th>
                                    <td class="tableLinerB tableLinerT text-left pl-5" style="width:30%">Agree</td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB" style="width:20%">위치기반서비스  이용약관(<span  color="red">필수</span>)</th>
                                    <td class="tableLinerB text-left pl-5" style="width:30%">Agree</td>
                                    <th class="listHeader tableLinerB" style="width:20%">전자금융거래 이용약관(<span  color="red">필수</span>)</th>
                                    <td class="tableLinerB text-left pl-5" style="width:30%">Agree</td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB " style="width:20%">마케팅정보 수신동의 (<span  color="red">선택</span>)</th>
                                    <td class="tableLinerB text-left pl-5" colspan="3" >{{MARKET_AGREE_INFO}}</td>
                                   
                                </tr>
                            </tbody>
                        </v-simple-table>

                        <div class="mt-10">
                        <div class="d-flex justify-space-between dense pa-0 ">
                            <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <!--
                                <v-btn color="red lighten-2" small dark class="ml-2 px-5">Delete</v-btn>
                                <v-btn color="primary" small dark class="ml-2 px-6" @click="editInfo()">Edit</v-btn>
                                -->
                            </div>
                        </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'MemberDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"5", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Member', disabled: true,}, { text: 'Member Management', disabled: true,}, { text: 'Member List', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [ 
                        {  title: 'Member Management', nums: '1',
                            items: [ { title: 'Member List', nums:11, href:'/Member', icons:'mdi-format-list-bulleted' }],
                        },
                        { title: 'Approve Management', nums: '2',
                            items: [ { title: 'Approve List', nums:21, href:'/MemberApproval', icons:'mdi-format-list-bulleted' }],
                        },
                    ], 

            modUsrID:'',      

            USR_NM:"", USR_COMPNAY_NAME:"", USR_COMPNAY_NUM:"", VC_NUMS:"", VC_IDTFY_NUMS:"",  
            CLASSFICATION:"", USR_TYPE:"", APRV_STATUS:"", APRV_INFO:"", INS_DTM:"",  HP :"", EMAIL :"",  COUNTRY_CODE:"", NAT_NAME_KR:"", MARKET_AGREE:"", 
            MARKET_AGREE_INFO:"",
            emptyFlag: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.modUsrID);
        this.modUsrID = this.$route.params.modUsrID;
        if(this.modUsrID == '' || this.modUsrID == undefined) {
            this.modUsrID = localStorage.getItem("modUsrID");
        }

        if(this.modUsrID != '') {
            this.getInfo();
            //this.getHistory();
        } else {
            alert("Not Data");
            this.$router.replace('Member');
        }
        window.scrollTo(0, 0);
    },

    methods : {
        
        // API Async 
        getInfo() {
            
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "modUsrID": this.modUsrID
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/member.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    this.USR_NM = json.USR_NM; this.USR_COMPNAY_NAME = json.USR_COMPNAY_NAME; this.USR_COMPNAY_NUM = json.USR_COMPNAY_NUM; 
                    this.VC_NUMS = json.VC_NUMS; this.VC_IDTFY_NUMS = json.VC_IDTFY_NUMS;
                    this.CLASSFICATION = json.CLASSFICATION; this.USR_TYPE = json.USR_TYPE; 
                    this.APRV_STATUS = json.APRV_STATUS; this.APRV_INFO = json.APRV_INFO; 
                    this.INS_DTM = json.INS_DTM;
   
                    this.HP = json.HP; this.EMAIL=json.EMAIL;
                    this.COUNTRY_CODE = json.COUNTRY_CODE;
                    this.NAT_NAME_KR = json.NAT_NAME_KR;
                    this.MARKET_AGREE = json.MARKET_AGREE;
                    if(this.MARKET_AGREE=='Y') {
                        this.MARKET_AGREE_INFO = "Agree";
                    } else {
                        this.MARKET_AGREE_INFO = "Disagree";
                    }
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Member'});
        }

    }

}
</script>
